import React from "react";
import { AcceleratorGallery } from "../../components/accelerator/AcceleratorShared";
import { ACCELERATORS } from "../../utils/accelerators/constants";

export default function AcceleratorsPage() {
  return (
    <AcceleratorGallery
      eyebrow="Innovation Labs"
      title="Accelerators"
      subtitle="Ready-to-use building blocks for faster delivery in Jade Orion"
      data={ACCELERATORS}
      searchPlaceholder="Search accelerators…"
      emptyNoun="accelerator"
    />
  );
}
